module.exports = __webpack_public_path__ + "img/class2.3d7115cf.png";